import React, { createContext } from 'react'
import { FetchContextType } from './types'

/**
 * this function returns an object defining the properties for a fetch context
 * @template <FetchDataType> - the data type handled from this context fetcher
 * @param {Object} - any properties if the fetch context you wish to override
 * @return {FetchContextType} - the object defining the properties of a fetch context
 */
export function createFetchContextProps<FetchDataType>(
  overrides = {}
): FetchContextType<FetchDataType> {
  return {
    isFetching: false,
    sawError: false,
    response: undefined,
    extra: undefined,
    ...overrides
  }
}

/**
 * this function generates a default fetch context
 * @template <FetchDataType> - the data type handled from this context fetcher
 * @return {React.Context} - the default fetch context
 */
export function createFetchContext<FetchDataType>(): React.Context<
  FetchContextType<FetchDataType>
> {
  return createContext(createFetchContextProps())
}

export default createFetchContext<Record<string, unknown>>()
